import { NgModule } from '@angular/core'
import { RouterModule, Routes } from '@angular/router'
import { GenerativeAiDataComponent } from './pages/generative-ai-data/generative-ai-data.component'
import { GenerativeAiExternalResourcesComponent } from './pages/generative-ai-external-resources/generative-ai-external-resources.component'
import { GenerativeAiIssuesComponent } from './pages/generative-ai-issues/generative-ai-issues.component'
import { GenerativeAiOverviewComponent } from './pages/generative-ai-overview/generative-ai-overview.component'
import { GenerativeAiPoliciesAndInitiativesComponent } from './pages/generative-ai-policies-and-initiatives/generative-ai-policies-and-initiatives.component'
import { GenerativeAiPublicationsComponent } from './pages/generative-ai-publications/generative-ai-publications.component'
import { GenerativeAiVideosComponent } from './pages/generative-ai-videos/generative-ai-videos.component'

export const generativeAiRoutes: Routes = [
  {
    path: '',
    component: GenerativeAiOverviewComponent
  },
  {
    path: 'data',
    component: GenerativeAiDataComponent
  },
  {
    path: 'external-resources',
    component: GenerativeAiExternalResourcesComponent
  },
  {
    path: 'issues/overview',
    component: GenerativeAiIssuesComponent,
    data: {
      dynamicPageSlug: 'generative-ai-issues-overview',
      title: 'Overview'
    }
  },
  {
    path: 'issues/benefits',
    component: GenerativeAiIssuesComponent,
    data: {
      dynamicPageSlug: 'generative-ai-issues-benefits',
      title: 'Benefits'
    }
  },
  {
    path: 'issues/risks-and-unknowns',
    component: GenerativeAiIssuesComponent,
    data: {
      dynamicPageSlug: 'generative-ai-issues-risks-and-unknowns',
      title: 'Risks and Unknowns'
    }
  },
  {
    path: 'policies-and-initiatives',
    component: GenerativeAiPoliciesAndInitiativesComponent
  },
  {
    path: 'publications',
    component: GenerativeAiPublicationsComponent
  },
  {
    path: 'videos',
    component: GenerativeAiVideosComponent
  }
]

@NgModule({
  imports: [RouterModule.forChild(generativeAiRoutes)],
  exports: [RouterModule]
})
export class GenerativeAiRoutingModule {}
